import { withPrefix } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'
import { Helmet } from 'react-helmet-async'

import Footer from './Footer'
import Navbar from './Navbar'

import useSiteMetadata from '../hooks/use-site-metadata'

import './all.css'

const TemplateWrapper = ({ children }) => {
  const { color } = useSiteMetadata()

  return (
    <>
      <Helmet>
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="HandheldFriendly" content="True" />

        <link
          rel="alternate"
          type="application/rss+xml"
          href={`${withPrefix('/')}rss.xml`}
        />
        <meta name="robots" content="max-image-preview:standard" />

        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${withPrefix('/')}img/apple-touch-icon.png`}
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix('/')}img/favicon-32x32.png`}
          sizes="32x32"
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix('/')}img/favicon-16x16.png`}
          sizes="16x16"
        />

        <link
          rel="mask-icon"
          href={`${withPrefix('/')}img/safari-pinned-tab.svg`}
          color="#ff4400"
        />
        <link rel="manifest" href="/manifest.webmanifest" />

        <link
          rel="preconnect"
          key="preconnect-images-cfassets"
          href="https://images.ctfassets.net"
        />
        <link
          rel="dns-prefetch"
          key="dns-prefetch-images-cfassets"
          href="https://images.ctfassets.net"
        />
        <link
          rel="preconnect"
          key="preconnect-analytics-planete-durable"
          href="https://a.planete-durable.fr"
        />
        <link
          rel="dns-prefetch"
          key="dns-prefetch-analytics-planete-durable"
          href="https://a.planete-durable.fr"
        />

        <meta name="ir-site-verification-token" value="-250541865" />

        <meta name="theme-color" content={color} />
        <meta name="msapplication-navbutton-color" content={color} />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta
          name="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />
        <meta name="msapplication-TileColor" content={color} />
      </Helmet>

      <div className="bg-gray-50 antialiased">
        <Navbar />

        {children}
        <Footer />
      </div>
    </>
  )
}

TemplateWrapper.propTypes = {
  children: PropTypes.node.isRequired,
}

export default TemplateWrapper
